/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "fa7218a218f97a88fd91941aab5d083b27195294";
